module.exports = __webpack_public_path__ + "img/background.9384e5a8.jpg";